import { render, staticRenderFns } from "./trendInfo.vue?vue&type=template&id=c375f692&scoped=true"
import script from "./trendInfo.vue?vue&type=script&lang=js"
export * from "./trendInfo.vue?vue&type=script&lang=js"
import style0 from "./trendInfo.vue?vue&type=style&index=0&id=c375f692&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c375f692",
  null
  
)

export default component.exports